 
export const message = {
  success: (m: any) => console.log(m),
  error: (m: any) => console.error(m),
  info: (m: any) => console.log(m),
  warning: (m: any) => console.warn(m),
};

export const Button: any = (p: any) => (
  <button
    {...p}
    style={{
      padding: '8px 12px',
      borderRadius: 8,
      border: '1px solid #334155',
      background: p.danger ? '#7f1d1d' : (p.type === 'primary' ? '#1d4ed8' : '#0f172a'),
      color: '#e2e8f0',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      ...p.style,
    }}
  >
    {p.icon ? <span style={{display:'inline-flex'}}>{p.icon}</span> : null}
    {p.children}
  </button>
);

export const Input: any = Object.assign(
  (p: any) => <input {...p} style={{...p.style, padding:'8px 10px', borderRadius:8, border:'1px solid #334155', background:'#0b1220', color:'#e2e8f0'}} />,
  { TextArea: (p: any) => <textarea {...p} style={{...p.style, padding:'8px 10px', borderRadius:8, border:'1px solid #334155', background:'#0b1220', color:'#e2e8f0'}} /> }
);

export const InputNumber: any = (p: any) => <input type="number" {...p} style={{...p.style, padding:'8px 10px', borderRadius:8, border:'1px solid #334155', background:'#0b1220', color:'#e2e8f0'}} />;

export const Select: any = (p: any) => (
  <select {...p} style={{...p.style, padding:'8px 10px', borderRadius:8, border:'1px solid #334155', background:'#0b1220', color:'#e2e8f0'}}>
    {p.options ? p.options.map((o:any, i:number) => <option key={o.value ?? i} value={o.value}>{o.label ?? o.children}</option>) : p.children}
  </select>
);

export const Switch: any = (p: any) => <input type="checkbox" checked={p.checked} onChange={(e)=>p.onChange?.(e.target.checked)} />;

export const Tabs: any = ({ items, activeKey, onChange }: any) => (
  <div>
    <div style={{display:'flex',gap:8}}>
      {items?.map((it:any) => <button key={it.key} onClick={() => onChange?.(it.key)}>{it.label}</button>)}
    </div>
    <div style={{marginTop:12}}>{items?.find((it:any)=>it.key===activeKey)?.children}</div>
  </div>
);

// Layout and display components
export const Row: any = (p:any) => <div {...p} style={{display:'flex', flexWrap:'wrap', gap:12, ...p.style}}>{p.children}</div>;
export const Col: any = (p:any) => <div {...p} style={{flex: p.span ? p.span/24 : undefined, ...p.style}}>{p.children}</div>;
export const Space: any = (p:any) => <div {...p} style={{display:'flex', flexDirection: p.direction==='vertical'?'column':'row', gap: p.size ?? 8, ...p.style}}>{p.children}</div>;

export const Card: any = ({ children, ...p }: any) => (
  <div {...p} style={{border:'1px solid #334155', borderRadius:12, padding:12, background:'#0b1220', ...p.style}}>{children}</div>
);

export const Badge: any = ({ count, children }: any) => (
  <div style={{position:'relative', display:'inline-block'}}>
    {children}
    {typeof count !== 'undefined' && (
      <span style={{position:'absolute', top:-6, right:-6, background:'#ef4444', color:'#fff', borderRadius:12, padding:'2px 6px', fontSize:12}}>{count}</span>
    )}
  </div>
);

export const Drawer: any = ({ open, onClose, children, title }: any) => open ? (
  <div onClick={onClose} style={{position:'fixed', inset:0, background:'#0007'}}>
    <div onClick={(e)=>e.stopPropagation()} style={{position:'absolute', top:0, right:0, height:'100%', width:400, background:'#0b1220', borderLeft:'1px solid #334155', padding:16}}>
      {title && <div style={{fontWeight:700, marginBottom:12}}>{title}</div>}
      {children}
    </div>
  </div>
) : null;

export const Empty: any = ({ description }: any) => (
  <div style={{border:'1px dashed #334155', borderRadius:12, padding:24, textAlign:'center', color:'#94a3b8'}}>{description || 'Nema podataka'}</div>
);

export const Tag: any = (p:any) => <span {...p} style={{display:'inline-block', padding:'2px 8px', borderRadius:8, border:'1px solid #334155', background:'#0b1220', ...p.style}}>{p.children}</span>;

export const Radio: any = (p:any) => <input type="radio" {...p} />;
export const Checkbox: any = (p:any) => <input type="checkbox" {...p} />;

export const Typography: any = {
   // eslint-disable-next-line
  Title: (p:any) => <h3 style={{margin:'8px 0'}} {...p} />,
  //eslint-ignore-next-line
  Text: (p:any) => <span {...p} />,
};

export const Upload: any = (p:any) => <input type="file" {...p} />;

export const Modal: any = ({ open, onCancel, onOk, title, children, okVisible=true,cancelVisible=true }: any) => open ? (
  <div onClick={onCancel} style={{position:'fixed', inset:0, background:'rgb(0 0 0 / 92%)', zIndex:1000}}>
    <div onClick={(e)=>e.stopPropagation()} style={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', background:'#0b1220', borderRadius:12, padding:24}}>
      {title && <div style={{fontWeight:700, marginBottom:12}}>{title}</div>}
      {children}
      <div style={{marginTop:12, display:'flex', justifyContent:'flex-end'}}>
        {cancelVisible && <Button onClick={onCancel} style={{marginRight:8}}>Cancel</Button>}
        {okVisible && <Button onClick={onOk}>OK</Button>}
      </div>
    </div>
  </div>
) : null;
